var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("lbl_transaction_breakdown"),
        width: "700px",
        footer: null
      },
      on: { cancel: _vm.handleClose }
    },
    [
      _c("a-table", {
        attrs: {
          columns: _vm.columns,
          "data-source": _vm.dataSource,
          loading: _vm.loading,
          pagination: false,
          size: "middle",
          "row-key": "id",
          scroll: { y: 400 },
          bordered: ""
        },
        scopedSlots: _vm._u([
          {
            key: "amount",
            fn: function(text) {
              return [_vm._v(" " + _vm._s(_vm.formatAmount(text)) + " ")]
            }
          }
        ])
      }),
      _c("div", { staticClass: "detail-footer" }, [
        _c("span", { staticClass: "detail-footer__label" }, [
          _vm._v(_vm._s(_vm.$t("lbl_total")))
        ]),
        _c("span", { staticClass: "detail-footer__amount" }, [
          _vm._v(_vm._s(_vm.formatAmount(_vm.totalAmount)))
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }